import { xeroScopeList } from './xero-setup';

export function XeroScopeChips({ scopes }: { scopes: string }) {
  return (
    <ul className="flex flex-wrap gap-1.5">
      {xeroScopeList(scopes).map((scope) => (
        <li
          key={scope}
          className="rounded border border-border bg-background px-1.5 py-0.5 font-mono text-[11px] text-foreground"
        >
          {scope}
        </li>
      ))}
    </ul>
  );
}
